import React, { useEffect, useState } from 'react';
import { MemoryRouter } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { CircularProgress } from '@mui/material';
import { StyledCardSection, StepsRouter } from '@fnol/library/src/components';
import { getApplicationId, getIsSalesForce } from '@fnol/library/src/lib';
import { IntroMessagesSlider } from '@fnol/library/src/components/IntroMessagesSlider';
import { legalPersonType } from '../../lib/consts';
import { authClient } from '@fnol/library/src/api/auth';
import stepsComposer from '../../lib/stepsComposer';
import introMessagesStepsComposer from '../../lib/introMessagesStepsComposer';
import waitingPeriodMessagesStepsComposer from '../../lib/waitingPeriodMessagesStepsComposer';
import { constValues } from '@fnol/library/src/lib';
import { prepareDataForSubmit } from '../../lib/helpers';
import { submitTemporaryData } from '../../rpc/actions';

const PpiApp = () => {
    const [loggedIn, setLoggedIn] = useState<boolean>(false);
    useEffect(() => {
        authClient.login('ppi', 281).then(() => setLoggedIn(true));
    }, []);

    return (
        <>
            {loggedIn ? (
                <Formik
                    enableReinitialize
                    initialValues={{
                        introMessagesOpen: true,
                        introMessagesSkipSteps: getIsSalesForce(getApplicationId()) ? [1, 2] : [],
                        waitingPeriodMessageOpen: false,
                        waitingPeriodAnswerGiven: false,
                        waitingPeriodMessageSkipSteps: [],
                        resetProcess: false,
                        policyNumber: '',
                        policyNumberOrUCN: '',
                        policyUCN: '',
                        dateOfOccurrence: '',
                        validFrom: '',
                        validTo: '',
                        policyNotFound: '',

                        loadingMessage: '',
                        errorMsgText: '',
                        uploadDocList: [],
                        numberOfWaitingPeriodDays: '',
                        numberOfWaitingDays: '',

                        risks: [],
                        roles: [],
                        risk: '', // whole selected object. id is sent to BE

                        submitterType: legalPersonType.initialValue,
                        submitterIndividualPersonRole: '', // whole selected object. id is sent to BE
                        submitterIndividualName: '',
                        submitterIndividualLastName: '',
                        submitterIndividualDateOfBirth: '',
                        submitterIndividualUCN: '',
                        submitterIndividualCountry: constValues.countrySerbiaId,
                        submitterIndividualCity: '',
                        submitterIndividualCityInSerbia: '', // whole selected object. id and label is sent to BE
                        submitterIndividualStreet: '',
                        submitterIndividualStreetNumber: '',
                        submitterIndividualEmail: '',
                        submitterIndividualPhone: constValues.dialCodeSerbia,

                        submitterLegalEntityPersonRole: '', // whole selected object. id is sent to BE
                        submitterLegalEntityCountry: constValues.countrySerbiaId,
                        submitterLegalEntityCity: '',
                        submitterLegalEntityCityInSerbia: '', // whole selected object. id and label is sent to BE
                        submitterLegalEntityStreet: '',
                        submitterLegalEntityStreetNumber: '',
                        submitterLegalEntityName: '',
                        submitterLegalEntityID: '',
                        submitterLegalEntityVAT: '',
                        submitterLegalEntityEmail: '',
                        submitterLegalEntityContactName: '',
                        submitterLegalEntityContactLastName: '',
                        submitterLegalEntityContactEmail: '',
                        submitterLegalEntityContactPhone: constValues.dialCodeSerbia,
                        skipSteps: [],
                    }}
                    onSubmit={(values, { setFieldValue, setSubmitting }) => {
                        submitTemporaryData(prepareDataForSubmit(values))
                            .then((response) => {
                                setFieldValue('tempID', response.data);
                                setFieldValue('submittedSuccessfully', true);
                                setFieldValue('submitError', '');
                                setSubmitting(false);
                            })
                            .catch((error) => {
                                setFieldValue('submittedSuccessfully', false);
                                setFieldValue('submitError', error.response?.data);
                                setSubmitting(false);
                            });
                    }}
                >
                    {({ values }) => (
                        <>
                            <MemoryRouter>
                                <IntroMessagesSlider
                                    open={values.introMessagesOpen}
                                    steps={introMessagesStepsComposer()}
                                    skipSteps={values.introMessagesSkipSteps}
                                />
                            </MemoryRouter>
                            <MemoryRouter>
                                <IntroMessagesSlider
                                    open={values.waitingPeriodMessageOpen}
                                    steps={waitingPeriodMessagesStepsComposer()}
                                    skipSteps={values.waitingPeriodMessageSkipSteps}
                                    infoSteper={true}
                                />
                            </MemoryRouter>
                            <Form>
                                <MemoryRouter>
                                    <StyledCardSection>
                                        <StepsRouter steps={stepsComposer()} skipSteps={values.skipSteps} />
                                    </StyledCardSection>
                                </MemoryRouter>
                            </Form>
                        </>
                    )}
                </Formik>
            ) : (
                <CircularProgress />
            )}
        </>
    );
};

export default PpiApp;
